import { Image, Video, AudioLines } from "lucide-react";
import { Tabs } from "@/components/ui/tabs";

export type Modality = "image" | "video" | "audio";

interface Props {
  value: Modality;
  compact?: boolean;
  onChange: (m: Modality) => void;
}

export function ModeTabs({ value, onChange, compact = false }: Props) {
  return (
    <Tabs<Modality>
      tabs={[
        { value: "image", label: "Image", icon: <Image className="h-3.5 w-3.5" /> },
        { value: "video", label: "Video", icon: <Video className="h-3.5 w-3.5" /> },
        { value: "audio", label: "Audio", icon: <AudioLines className="h-3.5 w-3.5" /> },
      ]}
      value={value}
      onChange={onChange}
      fullWidth
      className={compact ? "w-full [&_button]:px-2 [&_button]:text-xs [&_svg]:hidden" : "w-full"}
    />
  );
}
